import React from "react";
import { Form, Button, Card } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../Styles/BrandForm.scss";
import BackButton from "../Components/BackButton";
import BrandFormFields from "../Components/BrandFormFields";
import type { BrandFormRow } from "../Types/SocialListeningTypes";
import { SOCIAL_LISTENING_ROUTES } from "../Utils/SocialListeningConstants";

const BrandAnalysisForm: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = Form.useForm<BrandFormRow>();

  const onFinish = (brand: BrandFormRow) => {
    navigate(SOCIAL_LISTENING_ROUTES.loader, {
      state: { analysisType: "brand_analysis" as const, brand },
    });
    form.resetFields();
  };

  return (
    <div className="brand-form-container">
      <div className="brand-form-header">
        <BackButton label={t("socialListingAgent.brandForm.back")} />
      </div>

      <h1 className="brand-form-title">{t("socialListingAgent.brandForm.title")}</h1>
      <p className="brand-form-subtitle">{t("socialListingAgent.brandForm.subtitle")}</p>

      <Card className="brand-form-card">
        <Form layout="vertical" onFinish={onFinish} form={form}>
          <BrandFormFields scope="brandForm" handlePlaceholder="@yourbrand" />

          <div className="brand-form-buttons">
            <Button type="primary" htmlType="submit" className="button button--primary">
              {t("socialListingAgent.brandForm.startAnalysis")}
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default BrandAnalysisForm;
